import { Task, TaskLabel, TaskComment, TaskView } from "@/types/task-management";
import { addDays, subDays, format } from "date-fns";

// Função auxiliar para criar datas relativas a hoje
const today = new Date();
const formatDate = (date: Date) => format(date, "yyyy-MM-dd'T'HH:mm:ss");
const tomorrow = addDays(today, 1);
const nextWeek = addDays(today, 7);
const yesterday = subDays(today, 1);
const lastWeek = subDays(today, 7);

// Labels para tarefas
export const mockTaskLabels: TaskLabel[] = [
  { id: "label-1", name: "Importante", color: "#ef4444" },
  { id: "label-2", name: "Pessoal", color: "#3b82f6" },
  { id: "label-3", name: "Trabalho", color: "#10b981" },
  { id: "label-4", name: "Reunião", color: "#f59e0b" },
  { id: "label-5", name: "Ideia", color: "#8b5cf6" },
  { id: "label-6", name: "Cliente", color: "#ec4899" },
  { id: "label-7", name: "Documentação", color: "#6366f1" },
  { id: "label-8", name: "Financeiro", color: "#14b8a6" }
];

// Tarefas de exemplo
export const mockTasks: Task[] = [
  // Tarefas pessoais
  {
    id: "task-1",
    title: "Preparar apresentação para reunião de equipe",
    description: "Criar slides sobre o progresso do projeto e próximos passos",
    status: "todo",
    priority: "high",
    due_date: formatDate(tomorrow),
    created_at: formatDate(yesterday),
    updated_at: formatDate(yesterday),
    created_by: "user-1",
    assigned_to: "user-1",
    is_personal: true,
    labels: ["label-3", "label-4"],
    added_to_my_day: true,
    subtasks: [
      { id: "subtask-1", title: "Coletar dados de progresso", completed: true },
      { id: "subtask-2", title: "Criar gráficos", completed: false },
      { id: "subtask-3", title: "Revisar com o gerente", completed: false }
    ],
    comments: ["comment-1", "comment-2"],
    creator_name: "João Silva",
    creator_avatar: "/avatars/joao.jpg",
    assignee_name: "João Silva",
    assignee_avatar: "/avatars/joao.jpg"
  },
  {
    id: "task-2",
    title: "Revisar proposta comercial",
    description: "Analisar valores e condições antes de enviar ao cliente",
    status: "in_progress",
    priority: "urgent",
    due_date: formatDate(today),
    created_at: formatDate(lastWeek),
    updated_at: formatDate(yesterday),
    created_by: "user-1",
    assigned_to: "user-1",
    is_personal: true,
    labels: ["label-1", "label-6", "label-8"],
    added_to_my_day: true,
    subtasks: [],
    comments: [],
    creator_name: "João Silva",
    creator_avatar: "/avatars/joao.jpg",
    assignee_name: "João Silva",
    assignee_avatar: "/avatars/joao.jpg"
  },
  {
    id: "task-3",
    title: "Agendar reunião com equipe de desenvolvimento",
    status: "completed",
    priority: "medium",
    due_date: formatDate(yesterday),
    created_at: formatDate(lastWeek),
    updated_at: formatDate(yesterday),
    created_by: "user-1",
    assigned_to: "user-1",
    is_personal: true,
    labels: ["label-3", "label-4"],
    subtasks: [],
    comments: [],
    creator_name: "João Silva",
    creator_avatar: "/avatars/joao.jpg",
    assignee_name: "João Silva",
    assignee_avatar: "/avatars/joao.jpg"
  },
  {
    id: "task-4",
    title: "Atualizar documentação do projeto",
    description: "Incluir novas funcionalidades e correções recentes",
    status: "todo",
    priority: "low",
    due_date: formatDate(nextWeek),
    created_at: formatDate(yesterday),
    updated_at: formatDate(yesterday),
    created_by: "user-1",
    assigned_to: "user-1",
    is_personal: true,
    labels: ["label-3", "label-7"],
    subtasks: [],
    comments: [],
    creator_name: "João Silva",
    creator_avatar: "/avatars/joao.jpg",
    assignee_name: "João Silva",
    assignee_avatar: "/avatars/joao.jpg"
  },
  
  // Tarefas de playbooks
  {
    id: "task-5",
    title: "Configurar ambiente do cliente",
    description: "Preparar instância e configurações iniciais",
    status: "in_progress",
    priority: "high",
    due_date: formatDate(tomorrow),
    created_at: formatDate(lastWeek),
    updated_at: formatDate(yesterday),
    created_by: "00000000-0000-0000-0000-000000000000",
    assigned_to: "user-1",
    playbook_id: "playbook-1",
    playbook_name: "Onboarding de Cliente",
    client_id: "client-1",
    client_name: "Empresa ABC",
    is_personal: false,
    labels: ["label-6"],
    added_to_my_day: true,
    subtasks: [],
    comments: ["comment-3"],
    creator_name: "Sistema",
    assignee_name: "João Silva",
    assignee_avatar: "/avatars/joao.jpg"
  },
  {
    id: "task-6",
    title: "Treinamento inicial com o cliente",
    description: "Apresentar funcionalidades básicas da plataforma",
    status: "todo",
    priority: "medium",
    due_date: formatDate(addDays(today, 3)),
    created_at: formatDate(lastWeek),
    updated_at: formatDate(lastWeek),
    created_by: "00000000-0000-0000-0000-000000000000",
    assigned_to: "user-1",
    playbook_id: "playbook-1",
    is_personal: false,
    labels: ["label-4", "label-6"],
    subtasks: [],
    comments: [],
    creator_name: "Sistema",
    assignee_name: "João Silva",
    assignee_avatar: "/avatars/joao.jpg",
    playbook_name: "Onboarding de Cliente",
    client_name: "Empresa ABC"
  },
  {
    id: "task-7",
    title: "Enviar documentação de boas-vindas",
    status: "completed",
    priority: "medium",
    due_date: formatDate(yesterday),
    created_at: formatDate(lastWeek),
    updated_at: formatDate(yesterday),
    created_by: "00000000-0000-0000-0000-000000000000",
    assigned_to: "user-1",
    playbook_id: "playbook-1",
    is_personal: false,
    labels: ["label-6", "label-7"],
    subtasks: [],
    comments: [],
    creator_name: "Sistema",
    assignee_name: "João Silva",
    assignee_avatar: "/avatars/joao.jpg",
    playbook_name: "Onboarding de Cliente",
    client_name: "Empresa ABC"
  },
  {
    id: "task-8",
    title: "Configurar integrações de API",
    description: "Conectar sistemas do cliente com nossa plataforma",
    status: "waiting",
    priority: "high",
    due_date: formatDate(addDays(today, 5)),
    created_at: formatDate(lastWeek),
    updated_at: formatDate(yesterday),
    created_by: "00000000-0000-0000-0000-000000000000",
    assigned_to: "user-1",
    playbook_id: "playbook-1",
    is_personal: false,
    labels: ["label-3", "label-6"],
    subtasks: [],
    comments: [],
    creator_name: "Sistema",
    assignee_name: "João Silva",
    assignee_avatar: "/avatars/joao.jpg",
    playbook_name: "Onboarding de Cliente",
    client_name: "Empresa ABC"
  },
  {
    id: "task-9",
    title: "Reunião de acompanhamento mensal",
    description: "Revisar métricas e planejar próximos passos",
    status: "todo",
    priority: "medium",
    due_date: formatDate(addDays(today, 10)),
    created_at: formatDate(yesterday),
    updated_at: formatDate(yesterday),
    created_by: "00000000-0000-0000-0000-000000000000",
    assigned_to: "user-1",
    playbook_id: "playbook-2",
    is_personal: false,
    labels: ["label-4", "label-6"],
    subtasks: [],
    comments: [],
    creator_name: "Sistema",
    assignee_name: "João Silva",
    assignee_avatar: "/avatars/joao.jpg",
    playbook_name: "Acompanhamento Mensal",
    client_name: "Empresa XYZ"
  },
  {
    id: "task-10",
    title: "Preparar relatório de uso",
    description: "Compilar dados de uso da plataforma pelo cliente",
    status: "todo",
    priority: "low",
    due_date: formatDate(addDays(today, 8)),
    created_at: formatDate(yesterday),
    updated_at: formatDate(yesterday),
    created_by: "00000000-0000-0000-0000-000000000000",
    assigned_to: "user-1",
    playbook_id: "playbook-2",
    is_personal: false,
    labels: ["label-6", "label-7"],
    subtasks: [],
    comments: [],
    creator_name: "Sistema",
    assignee_name: "João Silva",
    assignee_avatar: "/avatars/joao.jpg",
    playbook_name: "Acompanhamento Mensal",
    client_name: "Empresa XYZ"
  }
];

// Comentários de exemplo
export const mockTaskComments: TaskComment[] = [
  {
    id: "comment-1",
    task_id: "task-1",
    user_id: "user-1",
    content: "Adicionei os principais tópicos que precisamos abordar na apresentação.",
    created_at: formatDate(yesterday)
  },
  {
    id: "comment-2",
    task_id: "task-1",
    user_id: "user-2",
    content: "Sugiro incluirmos também os resultados do último trimestre para comparação.",
    created_at: formatDate(today)
  },
  {
    id: "comment-3",
    task_id: "task-5",
    user_id: "user-1",
    content: "Ambiente configurado com sucesso. Aguardando confirmação do cliente para prosseguir.",
    created_at: formatDate(yesterday)
  }
];

// Visualizações predefinidas
export const mockTaskViews: TaskView[] = [
  {
    id: "view-1",
    name: "Todas as atividades",
    type: "list",
    filters: {},
    sort: { field: "due_date", direction: "asc" }
  },
  {
    id: "view-2",
    name: "Tarefas pessoais",
    type: "list",
    filters: {
      is_personal: true
    },
    sort: { field: "due_date", direction: "asc" }
  },
  {
    id: "view-3",
    name: "Tarefas de playbooks",
    type: "list",
    filters: {
      is_personal: false
    },
    sort: { field: "due_date", direction: "asc" }
  },
  {
    id: "view-4",
    name: "Prioridade alta",
    type: "list",
    filters: {
      priority: ["high", "urgent"]
    },
    sort: { field: "due_date", direction: "asc" }
  },
  {
    id: "view-5",
    name: "Kanban",
    type: "kanban",
    filters: {},
    sort: { field: "priority", direction: "desc" }
  }
]; 